import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-sankey-semantics-topics',
  templateUrl: './sankey-semantics-topics.component.html',
  styleUrl: './sankey-semantics-topics.component.scss',
})
export class SankeySemanticsTopicsComponent {
  isLoading = true;
  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsTopicsTree$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsTopicsTree');
    });
    this.getChartData();
  }

  getChartData() {
    this.isLoading = true;
    this.analyticsService.getSemanticsTopicsTree().subscribe();
  }

  get truncated() {
    return !!this.analyticsService.semanticsTopicsTree$.value?.truncated;
  }

  get series() {
    return this.analyticsService.semanticsTopicsTree$.value?.series[0];
  }
}
